// NOTE: T3 ENV 公式ドキュメントを参照
// https://env.t3.gg/docs/core

import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
  // server: {
  //   DATABASE_URL: z.string().url(),
  // },

  /**
   * The prefix that client-side variables must have. This is enforced both at
   * a type-level and at runtime.
   */
  clientPrefix: 'VITE_',

  client: {
    VITE_ENVIRONMENT: z.enum(['local', 'development', 'staging', 'production']),
    VITE_API_URL: z.string().min(1),
    VITE_STRIPE_PUBLIC_KEY: z.string().min(1),
    VITE_FIREBASE_CONFIG: z.string().transform((val) => {
      try {
        const parsed = JSON.parse(val);
        const parsedResult = z
          .object({
            apiKey: z.string().min(1, 'apiKeyは必須です'),
            authDomain: z.string().min(1, 'authDomainは必須です'),
            projectId: z.string().min(1, 'projectIdは必須です'),
            storageBucket: z.string().min(1, 'storageBucketは必須です'),
            messagingSenderId: z.string().min(1, 'messagingSenderIdは必須です'),
            appId: z.string().min(1, 'appIdは必須です'),
            measurementId: z.string().optional(),
          })
          .safeParse(parsed);
        if (!parsedResult.success) {
          console.error(parsedResult.error);
          throw new Error(parsedResult.error.message);
        }
        return parsedResult.data;
      } catch {
        throw new Error(
          'VITE_FIREBASE_CONFIG は有効なJSON形式である必要があります',
        );
      }
    }),
  },

  /**
   * What object holds the environment variables at runtime. This is usually
   * `process.env` or `import.meta.env`.
   */
  runtimeEnv: import.meta.env,

  /**
   * By default, this library will feed the environment variables directly to
   * the Zod validator.
   *
   * This means that if you have an empty string for a value that is supposed
   * to be a number (e.g. `PORT=` in a ".env" file), Zod will incorrectly flag
   * it as a type mismatch violation. Additionally, if you have an empty string
   * for a value that is supposed to be a string with a default value (e.g.
   * `DOMAIN=` in an ".env" file), the default value will never be applied.
   *
   * In order to solve these issues, we recommend that all new projects
   * explicitly specify this option as true.
   */
  emptyStringAsUndefined: true,
});
